module.exports = __webpack_public_path__ + "img/box.a01c3a7.svg";